import { render, staticRenderFns } from "./Pinpoint.vue?vue&type=template&id=4e08ec67&scoped=true&"
import script from "./Pinpoint.vue?vue&type=script&lang=js&"
export * from "./Pinpoint.vue?vue&type=script&lang=js&"
import style0 from "./Pinpoint.vue?vue&type=style&index=0&id=4e08ec67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e08ec67",
  null
  
)

export default component.exports